import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
(function (w: any, d: Document, s: string, l: string, i: string) {
  w[l] = w[l] || [];
  w[l].push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js'
  });
  var f = d.getElementsByTagName(s)[0];
  var j = d.createElement(s) as HTMLScriptElement;
  var dl = l != 'dataLayer' ? '&l=' + l : '';
  j.async = true;
  j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
  f.parentNode?.insertBefore(j, f);
})(window, document, 'script', 'dataLayer', 'GTM-P25KMW4S');
// GTM noscript fallback
const noscriptIframe = document.createElement('noscript');
const iframe = document.createElement('iframe');
iframe.src = 'https://www.googletagmanager.com/ns.html?id=GTM-P25KMW4S';
iframe.height = '0';
iframe.width = '0';
iframe.style.display = 'none';
iframe.style.visibility = 'hidden';
noscriptIframe.appendChild(iframe);
document.body.insertBefore(noscriptIframe, document.body.firstChild);
// Google Analytics (gtag.js) - G-QKDELD5L52
const gtagScript = document.createElement('script');
gtagScript.async = true;
gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-QKDELD5L52';
document.head.appendChild(gtagScript);
(window as any).dataLayer = (window as any).dataLayer || [];
function gtag(...args: any[]) {
  ;
  (window as any).dataLayer.push(arguments);
}
gtag('js', new Date());
gtag('config', 'G-QKDELD5L52');
render(<App data-id="element-119" />, document.getElementById('root'));